import { z } from 'zod';

export const SessionActionDTO = z.union([z.literal('create'), z.literal('delete')]);

export type SessionActionDTO = z.infer<typeof SessionActionDTO>;
